export default {
    computed: {
        ponto() {
            return this.$store.state.ponto;
        },
        ponto_id() {
            return this.$route.params.id;
        }
    }
};
